import * as React from 'react'
import './facebook-quick-message.css'

export default class FacebookQuickMessage extends React.Component<any> {
  constructor(props: any) {
    super(props)
    this.state = {}
  }
  createMarkup() {
    return {
      __html: `<div class="fb-customerchat"
        attribution=setup_tool
        page_id="128153191158038"
        minimized="true"
        theme_color="#3a4c45"
        
        logged_in_greeting="G&#xf3;&#xf0;an dag, hvernig getum vi&#xf0; a&#xf0;sto&#xf0;a&#xf0;?"
        logged_out_greeting="G&#xf3;&#xf0;an dag, hvernig getum vi&#xf0; a&#xf0;sto&#xf0;a&#xf0;?">
      </div>`,
    }
  }
  render() {
    return <div dangerouslySetInnerHTML={this.createMarkup()} />
  }
}



// WEBPACK FOOTER //
// ./src/components/Shared/facebook-quick-message/facebook-quick-message.tsx